export default __webpack_public_path__ + "static/media/img-bg-service-import.6d55db83.svg";